<template lang="pug">
div(v-if="cadastroOriginal")
  el-tabs.tabs(
    @tab-click="handleClick",
    v-model="abaAtiva",
  )
    el-tab-pane.tab(name='qualificacao', v-if='isOnerosoGroup || isProcessoFisico || isReurb || isBancoDados')
      span(slot='label' id="GERAL")
        .label
          | Geral &nbsp
      informacoes-qualificacao(
        v-if="cadastroOriginal.tipo==='NAO_ONEROSO' || isReurb || isProcessoFisico || isBancoDados",
        :qualificacao="cadastroOriginal.qualificacao",
        :tipo="tipoCadastro(processo.tipo.nome)",
        :dataCadastro="processo.dataCadastro"
        :cadastroOriginal="cadastroOriginal",
        :pessoas="processo.pessoas",
        :compararQualificacao="compararRetificacoes.mudouQualificacaoDTO",
        :dataRetificacao="processo.dataRetificacao"
        :isProcessoFisico="isProcessoFisico"
        :idProcesso="processo.id"
        :versaoCadastro = "versaoCadastro"
        :isBancoDados="isBancoDados"
      )
      informacoes-qualificacao-oneroso(v-if="cadastroOriginal.tipo==='ONEROSO'", :qualificacao="cadastroOriginal.qualificacao", :endereco="cadastroOriginal.imovel.endereco", :tipo="processo.tipo.nome", :dataCadastro="processo.dataCadastro", :pessoas="processo.pessoas", :compararQualificacaoOneroso="compararRetificacoes.mudouQualificacaoDTO", :dataRetificacao="processo.dataRetificacao")
      informacoes-qualificacao-certidao(v-if="cadastroOriginal.tipo==='CERTIDAO_TITULO'", :qualificacao="cadastroOriginal.qualificacao", :tipo="processo.tipo.nome", :dataCadastro="processo.dataCadastro",:pessoas="processo.pessoas", :compararQualificacaoCertidao="compararRetificacoes.mudouQualificacaoDTO", :dataRetificacao="processo.dataRetificacao")

    el-tab-pane.tab(name='geralTeq', v-if="isTeqGroup")
      span(slot="label")
        .label
          | Geral &nbsp
      informacoes-qualificacao(:cadastroOriginal="cadastroOriginal" :qualificacao="cadastroOriginal.qualificacao", :tipo="processo.tipo.nome", :dataCadastro="processo.dataCadastro", :compararQualificacao="compararRetificacoes.mudouQualificacaoDTO", :dataRetificacao="processo.dataRetificacao", :pessoas="processo.pessoas")
    el-tab-pane.tab(name='cadastrante' v-if="!isBancoDados")
      span(slot="label" id="CADASTRANTE")
        .label
          | Cadastrante &nbsp
      informacoes-cadastrante(
        :cadastrante="cadastrante",
        :isOnerosoGroup="isOnerosoGroup",
        v-if="!isTeqGroup",
        :compararCadastrante="compararRetificacoes.mudouCadastranteDTO"
        :isProcessoFisico="isProcessoFisico"
        :isReurb="isReurb",
        :tipoProcesso="tipoProcesso"
      )
      div(v-for = "(membro, index) in cadastrante.membrosComunidade")
      app-teq-group(
        :cadastroOriginal="cadastroOriginal",
        :cadastrante="cadastrante",
        :show-membro-endereco="true",
        v-if="isTeqGroup"
        :compararTeqGroup="compararRetificacoes.mudouCadastranteDTO"
      )
      listagem-documentos(
        v-if="cadastrante.documentos && cadastrante.documentos.length > 0"
        :documentos="cadastrante.documentos",
        :protocoloCadastroOriginal="cadastroOriginal.protocolo"
        ownerDocumento="CADASTRANTE"
        :compararDocumentos="compararRetificacoes.mudouCadastranteDTO.mudouDocumentosCadastrante"
        :versaoCadastro = "versaoCadastro"
      )

    el-tab-pane.tab(name='interessado')
      span(slot="label" id="INTERESSADO")
        .label
          | Interessado &nbsp
      div(v-if="!isMultiplosInteressados")
        informacoes-interessado(
          :interessado="interessado",
          :cadastroOriginal="cadastroOriginal",
          :isOnerosoGroup="isOnerosoGroup",
          :isReurb="isReurb",
          :compararInteressado="compararRetificacoes.mudouInteressadoDTO"
          :versaoCadastro = "versaoCadastro"
          :isBancoDados="isBancoDados"
        )

        listagem-documentos(
          v-if="interessado.documentos && interessado.documentos.length > 0"
          :documentos="interessado.documentos",
          :protocoloCadastroOriginal="cadastroOriginal.protocolo"
          ownerDocumento="INTERESSADO"
          :compararDocumentos="compararRetificacoes.mudouInteressadoDTO.mudouDocumentosInteressado"
          :versaoCadastro = "versaoCadastro"
        )
      div(v-else)
        el-collapse
          el-collapse-item(v-for="(interessado, index) in interessadosLista", :title="interessado.pessoa.pessoaFisica.nome", :key="index")
            informacoes-interessado(
              :interessado="interessado",
              :cadastroOriginal="cadastroOriginal",
              :isOnerosoGroup="isOnerosoGroup",
              :isReurb="isReurb",
              :compararInteressado="compararRetificacoes.mudouInteressadoDTO"
              :versaoCadastro = "versaoCadastro"
            )

            app-divider(v-if="isReurb" label="Assinatura")
            assinatura-mobile(:assinatura="assinatura", v-if="isReurb", :isAssinaturaInserida="interessado.isAssinaturaInserida")

            listagem-documentos(
              v-if="interessado.documentos && interessado.documentos.length > 0"
              :documentos="interessado.documentos",
              :protocoloCadastroOriginal="cadastroOriginal.protocolo"
              ownerDocumento="INTERESSADOS",
              :idInteressado="interessado._id || interessado.id"
              :compararDocumentos="compararRetificacoes.mudouInteressadoDTO.mudouDocumentosInteressado"
              :versaoCadastro = "versaoCadastro"
            )
    el-tab-pane.tab(name='beneficiarios', v-if="isTeqGroup && beneficiarios.length > 0")
      span(slot="label")
        .label
          | Beneficiários &nbsp

      informacoes-beneficiarios(:beneficiarios="beneficiarios", :cadastroOriginal="cadastroOriginal", :isBeneficiariosDiferentes="compararRetificacoes.mudouBeneficiarios")

    el-tab-pane.tab(name='imovel')
      span(slot="label" id="IMOVEL")
        .label
          | Imóvel &nbsp
      div(v-if="processo.tipo.codigo !== 'REGULARIZACAO_URBANA' && processo.tipo.codigo !== 'REURB_INDIVIDUAL'")
        informacoes-imovel(
          :cadastroOriginal="cadastroOriginal",
          :isOneroso="cadastroOriginal.tipo === 'ONEROSO'"
          :isOnerosoGroup="cadastroOriginal.tipo === 'ONEROSO' || cadastroOriginal.tipo === 'NAO_ONEROSO'"
          :compararImovel="compararRetificacoes.mudouImovelDTO"
          :compararDestinacaoUsoImovel="compararRetificacoes.mudouDestinacaoUsoImovelDTO"
          :destinacaoUsoImovel="destinacaoUsoImovel",
          :isBancoDados="isBancoDados"
          :gleba="gleba"
        )
        app-divider(label="Dados do Registro" v-if="isProcessoFisico")
        informacoes-registro-imovel(
          v-if="isProcessoFisico"
          :cadastroOriginal="cadastroOriginal"
          :gleba="gleba"
        )
        listagem-documentos(
          v-if="imovel.documentos && imovel.documentos.length > 0"
          :documentos="imovel.documentos",
          :protocoloCadastroOriginal="cadastroOriginal.protocolo"
          ownerDocumento="IMOVEL",
          :isDetalhes="true",
          :interessado="interessado",
          :tempoOcupacao="imovel.tempoOcupacao"
          :compararDocumentos="compararRetificacoes.mudouImovelDTO.mudouDocumentosImovel"
          :versaoCadastro = "versaoCadastro"
        )
      div(v-else)
        informacoes-imovel-reurb(
          :cadastroOriginal="cadastroOriginal",
          :compararImovelReurb="compararRetificacoes.mudouImovelDTO"
          :isReurb="isReurb"
        )
    el-tab-pane.tab(name='destinacaoUso', v-if="!isPEAS && !isReurb && !isCCR && !isProcessoFisico && !isBancoDados")
      span(slot="label")
        .label
          | Destinação e uso do imóvel &nbsp
      informacoes-destinacaoUsoImovel(
        :destinacaoUsoImovel="destinacaoUsoImovel",
        :isOnerosoGroup="isOnerosoGroup",
        :protocoloCadastroOriginal="cadastroOriginal.protocolo"
        :compararDestinacaoUsoImovel="compararRetificacoes.mudouDestinacaoUsoImovelDTO"
      )

    el-tab-pane.tab(v-if="!isCCR && !isProcessoFisico && !isBancoDados" name='georreferenciamento')
      span(slot="label" id="GEORREFERENCIAMENTO")
        .label
          | Georreferenciamento &nbsp
      app-resumo-geo(
        :localizacao="processo.geometria"
        :geo="georreferenciamento",
        :id-mapa="`mapaResumo${Math.random() * (10 - 0) + 0}`",
        v-if="abaAtiva == 'georreferenciamento' && !hasNotGeoReferenciamentoMa",
        :showMapa="naoPossuiGeorreferenciamento",
        :exibeDocumentos="false",
        :isVisualizarCadastro="true",
        :isGeoBeneficiario="false",
        :idCadastro="processo.numeroProtocolo",
        :isCadastroOff="true",
        :idProcesso="processo.id",
        :possuiCredenciadoGeo="possuiCredenciado()",
        :cruzamentoCamada="processo.cruzamentoCamada"
        :compararResumoGeo="compararRetificacoes.mudouGeorreferenciamentoDTO"
      )
      span(v-else-if="abaAtiva == 'georreferenciamento' && hasNotGeoReferenciamentoMa")
        | Não foi informado nenhum dado durante o cadastro.

      listagem-documentos(
        v-if="(georreferenciamento.documentos && georreferenciamento.documentos.length > 0) || (processo.documentosAutenticaveis && processo.documentosAutenticaveis.length > 0)"
        :documentos="georreferenciamento.documentos",
        :documentosGeo="processo.documentosAutenticaveis",
        :protocoloCadastroOriginal="cadastroOriginal.protocolo"
        ownerDocumento="GEO",
        :addMarginTop="false"
        :compararDocumentos="compararRetificacoes.mudouGeorreferenciamentoDTO.mudouDocumentosGeorreferenciamento"
        :versaoCadastro = "versaoCadastro"
      )
    el-tab-pane.tab(name='dadosComplementares' v-if="isReurb")
      span(slot="label" id="DADOS_COMPLEMENTARES")
        .label
          | Dados Complementares &nbsp
      informacoes-complementares(
        :cadastroOriginal="cadastroOriginal"
      )

    el-tab-pane.tab(name='galeria' v-if="isReurb")
      span(slot="label" id="GALERIA")
        .label
          | Documentos &nbsp
      galeria(
        :srcList="galeria",
        :imovel="imovel",
        :documentosColetivo="documentosColetivo",
        :interessado="interessado",
        :protocolo="protocoloReurb",
        :compararGaleria="compararRetificacoes.mudouImovelDTO",
        :versaoCadastro="versaoCadastro"
        :loading="loadingGaleria"
      )
      div(v-if="cadastroOriginal.observacaoFotos").container-observacao
        app-display(
          id="OBSERVACAO_FOTOS",
          label="Observação:",
          :content="cadastroOriginal.observacaoFotos || '-'"
          :class = "'text'"
        )

    el-tab-pane.tab(name='termoCompromisso' v-if="!isBancoDados")
      span(slot="label" id="TERMO_COMPROMISSO")
        .label
          | Termo de compromisso &nbsp
      informacoes-termo-compromisso(:isReurb="isReurb" :isProcessoFisico="isProcessoFisico")
      app-divider(v-if="isReurb && hasAssinatura" label="Assinatura")
      assinatura-mobile(:assinatura="assinatura", v-if="isReurb && hasAssinatura", :isAssinaturaInserida="interessado.isAssinaturaInserida")

    el-tab-pane.tab(name='informacoesVtn' v-if="isBancoDados")
      span(slot="label" id="INFORMACOESVTN")
        .label
          | VTN &nbsp
      informacoes-vtn(
        :cadastroOriginal="cadastroOriginal"
      )
</template>

<script>
import { mapActions } from 'vuex'
import ListagemDocumentos from './informacoesCadastro/ListagemDocumentos'
import AppDisplay from './AppDisplay'
import InformacoesCadastrante from './informacoesCadastro/ma/InformacoesCadastrante'
import InformacoesInteressado from './informacoesCadastro/ma/InformacoesInteressado'
import InformacoesComplementares from './informacoesCadastro/ma/InformacoesComplementares'
import InformacoesDestinacaoUsoImovel from './informacoesCadastro/InformacoesDestinacaoUsoImovel'
import InformacoesImovel from './informacoesCadastro/InformacoesImovel'
import AppTeqGroup from './informacoesCadastro/TeqGroup'
import InformacoesBeneficiarios from './informacoesCadastro/InformacoesBeneficiarios.vue'
import AppVisualizarBeneficiario from './AppVisualizarBeneficiario'
import AppResumoGeo from './resumo/AppResumoGeo'
import AppResumoImovelBeneficiario from './resumo/AppResumoImovelBeneficiario'
import InformacoesQualificacao from './informacoesCadastro/ma/informacoesQualificacao'
import InformacoesQualificacaoCertidao from './informacoesCadastro/InformacoesQualificacaoCertidao'
import InformacoesQualificacaoOneroso from './informacoesCadastro/InformacoesQualificacaoOneroso'
import AppDivider from '@/components/AppDivider'
import InformacoesTermoCompromisso from '@/components/informacoesCadastro/InformacoesTermoCompromisso'
import AppCollapse from '@/components/AppCollapse'
import AppDependentes from './AppDependentes'
import InformacoesImovelReurb from './informacoesCadastro/ma/InformacoesImovelReurb'
import Galeria from './informacoesCadastro/Galeria'
import AssinaturaMobile from './informacoesCadastro/AssinaturaMobile'
import InformacoesRegistroImovel from './informacoesCadastro/InformacoesRegistroImovel.vue'

import AppButton from './AppButton'
import compararRetificacoesDefault from '../utils/pa/compararReticacoesDefault'
import InformacoesVtn from './informacoesCadastro/InformacoesVtn'
const { tiposProcessoFisico, tiposImagensReurb } = require('@/utils/ma/regrasAnalise').default

export default {

  components: {
    AppDivider,
    AppDisplay,
    InformacoesCadastrante,
    InformacoesInteressado,
    InformacoesDestinacaoUsoImovel,
    InformacoesImovel,
    InformacoesBeneficiarios,
    AppTeqGroup,
    AppResumoGeo,
    AppVisualizarBeneficiario,
    AppResumoImovelBeneficiario,
    InformacoesQualificacao,
    InformacoesQualificacaoCertidao,
    InformacoesQualificacaoOneroso,
    ListagemDocumentos,
    AppButton,
    InformacoesTermoCompromisso,
    AppCollapse,
    AppDependentes,
    InformacoesImovelReurb,
    Galeria,
    AssinaturaMobile,
    InformacoesRegistroImovel,
    InformacoesComplementares,
    InformacoesVtn
  },

  props: {
    processo: {
      type: Object,
      required: true
    },
    compararRetificacoes: {
      type: Object,
      default: compararRetificacoesDefault
    },
    versaoCadastro: {
      type: String,
      default: 'MAX(versao_json)'
    }
  },

  data () {
    return {
      beneficiarioId: [],
      abaAtiva: '',
      galeria: [],
      assinatura: [],
      tiposProcessoFisico,
      processoMae: {
        numeroProtocolo: ''
      },
      gleba: {
        matricula: '',
        nomeCartorio: '',
        livro: '',
        folha: '',
        nome: '',
        nomeMunicipioCartorio: ''
      },
      loadingGaleria: false
    }
  },

  mounted () {
    if (this.isOnerosoGroup || this.isReurb || this.isBancoDados) {
      this.abaAtiva = 'qualificacao'
    } else if (this.isTeqGroup) {
      this.abaAtiva = 'geralTeq'
    } else {
      this.abaAtiva = 'cadastrante'
    }
    this.setNumeroProtocolo()
  },

  computed: {
    cadastroOriginal () {
      return this.processo.dadosCadastro.dados ? this.processo.dadosCadastro.dados.cadastro : this.processo.dadosCadastro
    },
    protocoloReurb () {
      return this.processo.numeroProtocolo
    },
    documentosColetivo () {
      const despachos = (this.processo.processoMae?.despachos) || []
      return despachos.flatMap(d => d.documentos || [])
    },
    cadastrante () {
      return this.cadastroOriginal.cadastrante
        ? this.cadastroOriginal.cadastrante : {}
    },
    interessado () {
      return this.cadastroOriginal.interessado.pessoa
        ? this.cadastroOriginal.interessado : {}
    },
    destinacaoUsoImovel () {
      return this.cadastroOriginal.destinacaoUsoImovel
        ? this.cadastroOriginal.destinacaoUsoImovel : {}
    },
    beneficiarios () {
      return this.cadastroOriginal.beneficiarios ? this.cadastroOriginal.beneficiarios : []
    },
    imovel () {
      return this.cadastroOriginal.imovel
        ? this.cadastroOriginal.imovel : {}
    },

    georreferenciamento () {
      return this.cadastroOriginal.georreferenciamento ? this.cadastroOriginal.georreferenciamento : {}
    },

    localizacoes () {
      return this.cadastroOriginal.georreferenciamento.localizacoes
        ? this.cadastroOriginal.georreferenciamento.localizacoes : []
    },

    isOnerosoGroup () {
      return this.cadastroOriginal.tipo === 'ONEROSO' ||
             this.cadastroOriginal.tipo === 'NAO_ONEROSO' ||
             this.cadastroOriginal.tipo === 'CERTIDAO_TITULO' ||
             this.cadastroOriginal.tipo === 'REGULARIZACAO_URBANA'
    },
    tipoProcesso () {
      return this.cadastroOriginal.tipo
    },
    isTeqGroup () {
      return this.cadastroOriginal.tipo === 'TEQ' ||
             this.cadastroOriginal.tipo === 'PEAS'
    },
    isPEAS () {
      return this.cadastroOriginal.tipo === 'PEAS'
    },
    isReurb () {
      return this.processo.tipo.codigo === 'REURB_INDIVIDUAL'
    },
    isBancoDados () {
      return this.processo.tipo.codigo === 'BANCO_DADOS'
    },
    isCCR () {
      return this.processo.tipo.codigo === 'CANCELAMENTO_CLAUSULA_RESOLUTIVA'
    },
    hasNotGeoReferenciamentoMa () {
      return !this.georreferenciamento.documentos?.length &&
             !this.georreferenciamento.localizacoes?.length &&
             !this.georreferenciamento.idsLocalizacoes?.length
    },
    naoPossuiGeorreferenciamento () {
      return this.georreferenciamento.possuiGeorreferenciamento === 'NAO_POSSUI' || !this.georreferenciamento?.possuiGeorreferenciamento
    },
    isMultiplosInteressados () {
      return this.cadastroOriginal.isMultiplosInteressados
    },
    interessadosLista () {
      return this.cadastroOriginal.interessados.interessadosLista
    },
    isMembrosComunidade () {
      return this.cadastrante.tipo === 'MEMBROS_DA_COMUNIDADE'
    },
    isProcessoFisico () {
      return this.tiposProcessoFisico.includes(this.cadastroOriginal.tipo)
    },
    hasAssinatura () {
      return this.interessado.isAssinaturaInserida
    }
  },

  methods: {
    ...mapActions({
      gerarSegundaVia: 'cadastro/emitirSegundaVia',
      buscarFotosReurb: 'cadastro/buscarFotosReurb',
      buscarGleba: 'gleba/buscarGleba'
    }),

    setNumeroProtocolo () {
      if (this.processo?.numeroProtocolo) {
        if (this.processo?.dadosCadastro?.dados) {
          this.processo.dadosCadastro.dados = {
            ...this.processo.dadosCadastro.dados,
            protocolo: this.processo?.numeroProtocolo
          }
        }
        if (this.processo?.dadosCadastro) {
          this.processo.dadosCadastro = {
            ...this.processo.dadosCadastro,
            protocolo: this.processo?.numeroProtocolo
          }
        }
      }
    },

    async handleClick (tab) {
      this.abaAtiva = tab.name

      if (tab.name === 'galeria') {
        this.buscarFotos()
      } else if (this.isReurb && tab.name === 'termoCompromisso' && this.assinatura.length === 0) {
        this.assinatura = await this.buscarFotosReurb({idProcesso: this.processo.id, tipo: 'ASSINATURA'})
      } else if (tab.name === 'imovel' && this.isProcessoFisico) {
        this.handleGleba()
      }
    },
    async handleGleba () {
      if (this.imovel.idGleba) {
        this.gleba = await this.buscarGleba(this.imovel.idGleba)
      } else {
        this.gleba = {
          matricula: this.imovel.numeroMatricula,
          nomeCartorio: this.imovel.nomeCartorio,
          livro: this.imovel.livroMatricula,
          folha: this.imovel.numeroFolhaMatricula,
          nome: this.imovel.gleba,
          nomeMunicipioCartorio: this.imovel.municipioCartorio.nome
        }
      }
    },

    async buscarFotos () {
      try {
        this.loadingGaleria = true
        if (this.isReurb) {
          if ([1, '1', '1.0'].includes(this.versaoCadastro)) {
            this.galeria = await this.buscarFotosReurb({
              idProcesso: this.processo.id,
              protocolo: null,
              tipos: tiposImagensReurb
            })
          } else {
            this.galeria = []
          }
        } else {
          this.galeria = await this.buscarFotosReurb({
            idProcesso: this.processo.id,
            protocolo: this.processo.numeroProtocolo,
            tipos: tiposImagensReurb
          })
        }
      } catch (e) {
        console.error('Erro ao buscar fotos: ', e)
      } finally {
        this.loadingGaleria = false
      }
    },

    possuiCredenciado () {
      if (this.cadastroOriginal.tipo === 'ONEROSO' || this.cadastroOriginal.tipo === 'NAO_ONEROSO') {
        return this.processo.possuiCredenciadoGeo
      }
    },

    getCadastroComPessoaMembroComunidade (index) {
      let mudouCadastranteMembroComunidade = this.compararRetificacoes.mudouCadastranteDTO
      mudouCadastranteMembroComunidade = {
        ...mudouCadastranteMembroComunidade,
        mudouPessoa: mudouCadastranteMembroComunidade.mudouMembroComunidade.length > 0 ? mudouCadastranteMembroComunidade.mudouMembroComunidade[index].mudouPessoa : compararRetificacoesDefault().mudouPessoa,
        mudouEndereco: mudouCadastranteMembroComunidade.mudouMembroComunidade.length > 0 ? mudouCadastranteMembroComunidade.mudouMembroComunidade[index].mudouEndereco : compararRetificacoesDefault().mudouEndereco
      }
      return mudouCadastranteMembroComunidade
    },

    tipoCadastro (tipo) {
      return tipo
    }
  },

  watch: {
    versaoCadastro: {
      handler (val) {
        if (this.abaAtiva === 'galeria') {
          this.buscarFotos()
        } else if (this.abaAtiva === 'imovel' && this.isProcessoFisico) {
          this.handleGleba()
        }
      },
      deep: true,
      immediate: true
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/assets/styles/_variables.scss";

  .label {
    font-size: 16px;
  }

  body {
    word-break: break-word !important;
  }

  /deep/ .el-collapse-item__header {
    font-size: 16px;
    color: $font-dark-color;
    font-weight: bold;
  }

  /deep/ .el-collapse-item__content {
    font-size: unset !important;
    color: unset !important;
  }

  .container-observacao {
    margin-top: 30px;
  }

</style>



// WEBPACK FOOTER //
// src/components/InformacoesCadastroOfflinema.vue